import Switch from "rc-switch";
import "rc-switch/assets/index.css";
import React, { useCallback, useState } from "react";
import { FiAlertCircle, FiMenu } from "react-icons/fi";
import { useApi } from "../../hooks/api";
import { background, fail, info } from "../../theme";
import { useGlobal } from "../../hooks/global";
import { useNavigate } from "react-router-dom";
import { FaRegBuilding } from "react-icons/fa";
import { RiLockPasswordLine, RiLoginBoxLine } from "react-icons/ri";
import { ProfileButton } from "../Buttons/Profile";
import { LogoDark } from "../SvgComponents/Logo/Dark";
import { LogoLight } from "../SvgComponents/Logo/Light";
import { IPermissionsTypes } from "../../utils/permissions";
import { Button, Container, ContainerLogo, Content, Logo, SwitchContainer } from "./style";
import { ModalChangePassword } from "../Modals/ModalChangePassword";
import { CgProfile } from "react-icons/cg";
import { useWallet } from "../../hooks/wallet";
import { subscription_description_header, subscription_situations_header } from "../../utils/subscriptionSituantions";
import { correctDate3 } from "../../services/generalServices";
import { IoClose } from "react-icons/io5";

interface HeaderProps {
  chooseFranchise?: boolean;
}

const options: { name: string; icon: React.ReactElement; permissions?: IPermissionsTypes[] }[] = [
  { name: "Meu Perfil", icon: <CgProfile size={16} /> },
  { name: "Dados da Empresa", icon: <FaRegBuilding size={16} />, permissions: ['SETTINGS-UPDATE'] },
  { name: "Alterar Senha", icon: <RiLockPasswordLine size={16} /> },
  { name: "Sair", icon: <RiLoginBoxLine size={16} /> }
]

export const Header: React.FC<HeaderProps> = (props) => {
  const [openModal, setOpenModal] = useState(false);

  const { chooseFranchise } = props;

  const navigate = useNavigate();

  const { signOut, user } = useApi();
  const { setMenuOpen, menuOpen, setTheme, theme, menuItemSelected, setSubMenuOpen, subMenuOpen, seeNotification, setSeeNotification, business } = useGlobal();
  const { subscription } = useWallet();

  const clickButtonMenu = useCallback(() => {
    if (subMenuOpen) setSubMenuOpen(false);
    else setMenuOpen(!menuOpen);
  }, [menuOpen, menuItemSelected, subMenuOpen]);

  const toggleFullScreen = () => {
    if (document.fullscreenEnabled) {
      if (!document.fullscreen) document.documentElement.requestFullscreen();
      else document.exitFullscreen();
    }
  };

  const clickInOption = useCallback((id, option) => {
    if (option === "Sair") signOut();
    else if (option === "Meu Perfil") navigate("/settings/perfil");
    else if (option === "Dados da Empresa") navigate("/settings/company-data");
    else if (option === "Alterar Senha") setOpenModal(true);
  }, []);

  const addDays = (date: any, days: number) => {
    const copy = new Date(date);
    copy.setDate(date.getDate() + days);
    return copy;
  };

  const expireDate = addDays(new Date(
    subscription?.transactions?.[0]?.createdAt as any ??
    business?.business_data?.expire_free_test
  ),
    business?.subscriptions?.transactions?.[0]?.createdAt ? 7 : 0
  );

  const now = new Date();

  expireDate.setHours(0, 0, 0, 0);
  now.setHours(0, 0, 0, 0);

  return (
    <Container id="header-content" theme={theme}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minWidth: "100vw",
        }}
      >
        {seeNotification && subscription?.situation &&
          user?.user_type?.name === 'ADMINISTRADOR' &&
          (
            ["waiting-alert", "waiting-block"].includes(subscription?.situation) ||
            business?.business_data?.is_free_test
          ) &&
          now < expireDate
          && (
            <div
              style={{
                padding: 16,
                paddingRight: 26,
                background: `${business?.business_data?.is_free_test ? '#fff6cd' : '#FDEAE8'}`,
                display: "flex",
                gap: 10,
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 5,
                  flex: 1,
                }}
              >
                <div style={{ display: "flex", gap: 5, alignItems: "center" }}>
                  <FiAlertCircle size={23} color={`${business?.business_data?.is_free_test ? info : fail}`} />
                  <b style={{ fontSize: 18 }}>
                    {
                      subscription_situations_header?.[subscription?.situation ?? 'paid-free']?.text
                        ? subscription_situations_header[subscription?.situation ?? 'paid-free'].text
                        : subscription_situations_header['paid-free'].text
                    }
                  </b>
                </div>
                <div style={{ marginLeft: 28 }}>
                  {(subscription?.situation === "waiting-alert" || subscription?.situation === "waiting-block") && (
                    <>
                      {subscription_description_header['waiting-alert']}{" "}
                      {correctDate3(
                        addDays(
                          new Date(
                            subscription?.transactions?.[0]?.createdAt as any
                          ),
                          7
                        ),
                        { month_in_extension: true }
                      )}
                      . Caso já tenha pago, ignore essa notificação.
                      <b
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate("/subscription")}
                      >
                        {" "}
                        Clique aqui para reguralizar a sua situação
                      </b>
                    </>
                  )}
                  {subscription?.situation === "paid-free" || business?.business_data?.is_free_test && (
                    <>
                      {subscription_description_header['paid-free']}{" "}
                      Encerrando este período no dia{" "}
                      {correctDate3(
                        addDays(
                          new Date(
                            subscription?.transactions?.[0]?.createdAt as any ??
                            business?.business_data?.expire_free_test
                          ),
                          subscription?.transactions?.[0]?.createdAt ? 7 : 0
                        ),
                        { month_in_extension: true }
                      )}
                      .
                      <b
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate("/subscription")}
                      >
                        {" "}
                        Clique aqui para assinar um novo plano
                      </b>
                    </>
                  )}
                </div>
              </div>
              <div>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => setSeeNotification(false)}
                >
                  <IoClose size={20} />
                </div>
              </div>
            </div>
          )}

        <Content>
          <ContainerLogo chooseFranchise={!!chooseFranchise}>
            <Logo chooseFranchise={!!chooseFranchise}>
              {theme === "dark" && <LogoDark />}
              {theme === "light" && <LogoLight />}
            </Logo>
            {!chooseFranchise && (
              <FiMenu
                onClick={clickButtonMenu}
                style={{ cursor: "pointer" }}
                color={background[theme === "dark" ? "light" : "dark"]}
                size={30}
              />
            )}
          </ContainerLogo>
          <div style={{ display: "flex", alignItems: "center" }}>
            <SwitchContainer>
              <Switch
                id="tooltip_switch"
                className="custom-switch custom-switch-primary custom-switch-small"
                checked={theme === "dark"}
                onChange={(value) => setTheme(value ? "dark" : "light")}
              />
            </SwitchContainer>

            <Button onClick={toggleFullScreen} isCollapse theme={theme}>
              <i
                className="i-Full-Screen"
                color="#FFF"
                data-fullscreen
                style={{ color: "#6c757d", fontSize: 22 }}
              />
            </Button>

            <ProfileButton
              id="profile-button"
              photo={null}
              onClick={clickInOption}
              options={options.filter(({ permissions = [] }) => permissions.every(permission => user?.user_type?.permissions?.includes(permission)))}
              theme={theme}
            />
          </div>
        </Content>
      </div>

      <ModalChangePassword
        openModal={openModal}
        onCancel={() => setOpenModal(false)}
        onSave={() => setOpenModal(false)}
      />
    </Container>
  );
};
